import { render, staticRenderFns } from "./TypeFacture.vue?vue&type=template&id=4d76c68c&scoped=true&"
import script from "./TypeFacture.vue?vue&type=script&lang=js&"
export * from "./TypeFacture.vue?vue&type=script&lang=js&"
import style0 from "./TypeFacture.vue?vue&type=style&index=0&id=4d76c68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d76c68c",
  null
  
)

export default component.exports